module.exports = {"id":"202652","name":"Raheem Sterling","rating":"84","photo":"./data/images/photos/0/202652.png","club":{"name":"Manchester City","logo":"./data/images/clubs/ManchesterCity.png"},"positions":["AD","AG","ATT"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RaheemSterling0.json
// module id = 3524
// module chunks = 0